// Day 4 - Full Production Content (PREMIUM)
// Temat: AI w codziennej pracy + AI Coach wprowadzenie
// Ton: praktyczny, profesjonalny, premium
// Duration: 12-15 minutes

export const day4Content = {
  day_number: 4,
  title: "AI w Twojej codziennej pracy",
  subtitle: "Praktyczne zastosowania + AI Coach",
  duration: "12-15 min",
  is_premium: true,
  has_ai_coach: true,
  exercises: [
    // ═══════════════════════════════════════════════════════════════
    // ĆWICZENIE 1: Wprowadzenie do AI Coacha (5 kroków)
    // Cel: Przedstawić AI Coacha jako narzędzie wsparcia
    // ═══════════════════════════════════════════════════════════════
    {
      id: "d4_ex1",
      title: "Poznaj swojego AI Coacha",
      icon: "sparkles",
      steps: [
        {
          id: "d4_ex1_s1",
          type: "choice",
          title: "Nowa funkcja PRO",
          content: "Od dziś masz dostęp do AI Coacha – osobistego asystenta, który pomoże Ci w nauce promptów. Gdzie go znajdziesz?",
          options: [
            { id: "a", text: "Ikona robota w prawym dolnym rogu podczas lekcji", correct: true },
            { id: "b", text: "W menu głównym aplikacji", correct: false },
            { id: "c", text: "Tylko na stronie głównej", correct: false },
            { id: "d", text: "Trzeba go pobrać osobno", correct: false }
          ],
          shuffle: true,
          softHint: "AI Coach jest dostępny podczas każdej lekcji – szukaj ikony w rogu.",
          successMessage: "Dokładnie! AI Coach jest zawsze pod ręką podczas nauki."
        },
        {
          id: "d4_ex1_s2",
          type: "choice",
          title: "Do czego służy AI Coach?",
          content: "AI Coach pomoże Ci w:",
          options: [
            { id: "a", text: "Tylko w pisaniu promptów za Ciebie", correct: false },
            { id: "b", text: "Wyjaśnianiu trudnych pojęć, odpowiadaniu na pytania i dawaniu wskazówek", correct: true },
            { id: "c", text: "Tylko w tłumaczeniu na angielski", correct: false },
            { id: "d", text: "Tylko w sprawdzaniu błędów", correct: false }
          ],
          shuffle: true,
          softHint: "AI Coach to Twój mentor – pomaga zrozumieć, nie robi za Ciebie.",
          successMessage: "Tak! AI Coach wyjaśnia, doradza i pomaga zrozumieć – nie zastępuje Twojej pracy."
        },
        {
          id: "d4_ex1_s3",
          type: "choice",
          title: "Limit dzienny",
          content: "AI Coach ma dzienny limit wiadomości. Dlaczego?",
          options: [
            { id: "a", text: "Żebyś sam myślał i uczył się, a nie tylko pytał AI", correct: true },
            { id: "b", text: "Bo AI jest drogi w utrzymaniu", correct: false },
            { id: "c", text: "Bo serwery są przeciążone", correct: false },
            { id: "d", text: "Bez powodu", correct: false }
          ],
          shuffle: true,
          softHint: "Limit zachęca do samodzielnego myślenia – to część procesu nauki.",
          successMessage: "Dokładnie! Limit sprawia, że zadajesz przemyślane pytania i uczysz się efektywniej."
        },
        {
          id: "d4_ex1_s4",
          type: "choice",
          title: "Jak najlepiej używać AI Coacha?",
          content: "Która strategia jest najlepsza?",
          options: [
            { id: "a", text: "Pytać o wszystko natychmiast", correct: false },
            { id: "b", text: "Najpierw spróbować samemu, potem pytać o konkretne trudności", correct: true },
            { id: "c", text: "Nigdy nie pytać", correct: false },
            { id: "d", text: "Prosić o gotowe odpowiedzi", correct: false }
          ],
          shuffle: true,
          softHint: "Najlepiej uczysz się, gdy najpierw spróbujesz sam.",
          successMessage: "Świetnie! Najpierw próba, potem wsparcie – to klucz do skutecznej nauki."
        },
        {
          id: "d4_ex1_s5",
          type: "aiCoachIntro",
          title: "Wypróbuj AI Coacha!",
          content: "Teraz masz szansę wypróbować AI Coacha. Kliknij przycisk poniżej i zadaj mu pytanie o cokolwiek związanego z promptami!",
          buttonText: "Otwórz AI Coacha",
          softHint: "Nie bój się pytać – AI Coach jest tutaj, żeby pomóc!",
          successMessage: "Świetnie! Teraz wiesz, jak korzystać z AI Coacha."
        }
      ]
    },

    // ═══════════════════════════════════════════════════════════════
    // ĆWICZENIE 2: AI w pracy biurowej (6 kroków)
    // Cel: Pokazać praktyczne zastosowania w codziennej pracy
    // ═══════════════════════════════════════════════════════════════
    {
      id: "d4_ex2",
      title: "AI w pracy biurowej",
      icon: "briefcase",
      steps: [
        {
          id: "d4_ex2_s1",
          type: "choice",
          title: "Największe oszczędności czasu",
          content: "W którym zadaniu biurowym AI może zaoszczędzić NAJWIĘCEJ czasu?",
          options: [
            { id: "a", text: "Pisanie emaili i odpowiedzi", correct: false },
            { id: "b", text: "Powtarzalne zadania: raporty, podsumowania, notatki ze spotkań", correct: true },
            { id: "c", text: "Logowanie do systemu", correct: false },
            { id: "d", text: "Picie kawy", correct: false }
          ],
          shuffle: true,
          softHint: "Pomyśl: które zadania robisz wielokrotnie w podobny sposób?",
          successMessage: "Tak! Powtarzalne zadania to idealne miejsce na AI – robisz szablon raz, używasz wielokrotnie."
        },
        {
          id: "d4_ex2_s2",
          type: "choice",
          title: "Notatki ze spotkania",
          content: "Masz nagranie 30-minutowego spotkania. Który prompt da najlepsze podsumowanie?",
          options: [
            { id: "a", text: "\"Podsumuj spotkanie\"", correct: false },
            { id: "b", text: "\"Stwórz podsumowanie spotkania: 1) Kluczowe decyzje, 2) Action items z przypisanymi osobami, 3) Terminy, 4) Następne kroki. Format: punkty, max 1 strona.\"", correct: true },
            { id: "c", text: "\"Co powiedziano na spotkaniu?\"", correct: false },
            { id: "d", text: "\"Spotkanie – napisz coś\"", correct: false }
          ],
          shuffle: true,
          softHint: "Dobry prompt określa strukturę, elementy i format.",
          successMessage: "Dokładnie! Ten prompt daje gotowy do użycia dokument z jasną strukturą."
        },
        {
          id: "d4_ex2_s3",
          type: "shortPrompt",
          title: "Twój prompt na email",
          content: "Napisz prompt do stworzenia profesjonalnego emaila z podziękowaniem po spotkaniu z klientem:",
          placeholder: "Jako asystent biznesowy, napisz email...",
          minLength: 60,
          requiredElements: ["email", "spotkani|klient", "podziękowan|follow"],
          softHint: "Określ rolę AI, cel emaila, ton i format.",
          successMessage: "Świetny prompt! Taki email zrobi dobre wrażenie."
        },
        {
          id: "d4_ex2_s4",
          type: "choice",
          title: "Raport tygodniowy",
          content: "Szef chce raport tygodniowy. Który prompt jest najlepszy?",
          options: [
            { id: "a", text: "\"Napisz raport\"", correct: false },
            { id: "b", text: "\"Raport tygodniowy, proszę\"", correct: false },
            { id: "c", text: "\"Jako analityk biznesowy, stwórz raport tygodniowy dla zespołu sprzedaży. Sekcje: 1) Podsumowanie wyników, 2) Top 3 sukcesy, 3) Wyzwania, 4) Priorytety na przyszły tydzień. Ton: profesjonalny, max 1 strona.\"", correct: true },
            { id: "d", text: "\"Co robiliśmy w tym tygodniu?\"", correct: false }
          ],
          shuffle: true,
          softHint: "Dobry raport ma jasną strukturę i jest zwięzły.",
          successMessage: "Właśnie tak! Ten prompt daje gotowy szablon raportu."
        },
        {
          id: "d4_ex2_s5",
          type: "classify",
          title: "Zadania dla AI vs. dla Ciebie",
          content: "Przypisz zadania do kategorii:",
          categories: ["AI może zrobić", "Lepiej zrobić samemu"],
          items: [
            { id: "c1", text: "Pierwsze drafty emaili", category: "AI może zrobić" },
            { id: "c2", text: "Decyzje strategiczne", category: "Lepiej zrobić samemu" },
            { id: "c3", text: "Formatowanie dokumentów", category: "AI może zrobić" },
            { id: "c4", text: "Budowanie relacji z klientem", category: "Lepiej zrobić samemu" },
            { id: "c5", text: "Podsumowania danych", category: "AI może zrobić" },
            { id: "c6", text: "Negocjacje", category: "Lepiej zrobić samemu" }
          ],
          softHint: "AI świetnie radzi sobie z przetwarzaniem informacji, ale ludzkie relacje wymagają Ciebie.",
          successMessage: "Świetnie! Wiesz, kiedy użyć AI, a kiedy działać osobiście."
        },
        {
          id: "d4_ex2_s6",
          type: "fill",
          title: "Złota zasada",
          content: "Dokończ zdanie o AI w pracy:",
          template: "AI to narzędzie, które _______ Twoją pracę, ale jej nie zastępuje.",
          correctAnswers: ["wspiera", "przyspiesza", "ułatwia", "wspomaga", "usprawnia"],
          minLength: 5,
          softHint: "AI to asystent, nie zamiennik.",
          successMessage: "Dokładnie! AI wspiera, ale Ty jesteś ekspertem."
        }
      ]
    },

    // ═══════════════════════════════════════════════════════════════
    // ĆWICZENIE 3: AI w content marketingu (6 kroków)
    // Cel: Pokazać zastosowania w tworzeniu treści
    // ═══════════════════════════════════════════════════════════════
    {
      id: "d4_ex3",
      title: "AI w content marketingu",
      icon: "edit",
      steps: [
        {
          id: "d4_ex3_s1",
          type: "choice",
          title: "Gdzie AI błyszczy w marketingu?",
          content: "W którym zadaniu marketingowym AI jest NAJBARDZIEJ pomocne?",
          options: [
            { id: "a", text: "Wymyślanie strategii od zera", correct: false },
            { id: "b", text: "Generowanie wielu wariantów treści (nagłówki, opisy, CTA)", correct: true },
            { id: "c", text: "Rozumienie potrzeb klientów", correct: false },
            { id: "d", text: "Budowanie marki osobistej", correct: false }
          ],
          shuffle: true,
          softHint: "AI świetnie radzi sobie z generowaniem WARIANTÓW na podstawie Twoich wytycznych.",
          successMessage: "Tak! AI może wygenerować 10 wersji nagłówka w minutę – Ty wybierasz najlepszy."
        },
        {
          id: "d4_ex3_s2",
          type: "choice",
          title: "Nagłówki reklamowe",
          content: "Potrzebujesz 5 nagłówków do reklamy kursu online. Który prompt jest najlepszy?",
          options: [
            { id: "a", text: "\"Napisz nagłówki\"", correct: false },
            { id: "b", text: "\"5 nagłówków do reklamy\"", correct: false },
            { id: "c", text: "\"Jako copywriter, napisz 5 nagłówków reklamowych do kursu online o inwestowaniu dla początkujących. Styl: konkretne korzyści, bez przesady. Max 10 słów każdy. Różne podejścia: problem, korzyść, ciekawość, dowód społeczny, pilność.\"", correct: true },
            { id: "d", text: "\"Pomóż z reklamą kursu\"", correct: false }
          ],
          shuffle: true,
          softHint: "Dobry prompt określa format, styl i różne podejścia.",
          successMessage: "Świetnie! Ten prompt da Ci różnorodne nagłówki do testowania."
        },
        {
          id: "d4_ex3_s3",
          type: "shortPrompt",
          title: "Post na LinkedIn",
          content: "Napisz prompt na angażujący post LinkedIn o tym, jak AI zmienia Twoją branżę:",
          placeholder: "Jako ekspert od contentu, napisz post...",
          minLength: 70,
          requiredElements: ["linkedin|post", "ai|sztuczn", "branż|prac|biznes"],
          softHint: "LinkedIn lubi: hook w pierwszej linii, wartość merytoryczna, pytanie do dyskusji.",
          successMessage: "Doskonały prompt! Taki post przyciągnie uwagę i komentarze."
        },
        {
          id: "d4_ex3_s4",
          type: "choice",
          title: "Opis produktu",
          content: "Piszesz opis produktu dla e-commerce. Co jest NAJWAŻNIEJSZE w prompcie?",
          options: [
            { id: "a", text: "Długość opisu", correct: false },
            { id: "b", text: "Określenie grupy docelowej i głównej korzyści", correct: true },
            { id: "c", text: "Użycie słowa \"rewolucyjny\"", correct: false },
            { id: "d", text: "Dodanie emoji", correct: false }
          ],
          shuffle: true,
          softHint: "Opis musi trafiać do konkretnego klienta z konkretną obietnicą.",
          successMessage: "Właśnie! Grupa docelowa + korzyść = skuteczny opis."
        },
        {
          id: "d4_ex3_s5",
          type: "reorder",
          title: "Proces tworzenia treści z AI",
          content: "Ułóż optymalny proces tworzenia treści z AI:",
          items: [
            { id: "r1", text: "Określ cel i grupę docelową", order: 1 },
            { id: "r2", text: "Napisz prompt z wytycznymi", order: 2 },
            { id: "r3", text: "Wygeneruj kilka wariantów", order: 3 },
            { id: "r4", text: "Wybierz najlepszy i edytuj", order: 4 },
            { id: "r5", text: "Dodaj osobisty akcent", order: 5 }
          ],
          softHint: "AI generuje, Ty selekcjonujesz i personalizujesz.",
          successMessage: "To jest profesjonalny workflow content marketingu z AI!"
        },
        {
          id: "d4_ex3_s6",
          type: "choice",
          title: "Autentyczność treści",
          content: "Jak zachować autentyczność, używając AI do contentu?",
          options: [
            { id: "a", text: "Publikować wszystko, co AI wygeneruje", correct: false },
            { id: "b", text: "Używać AI jako punktu wyjścia, ale dodawać własne doświadczenia i styl", correct: true },
            { id: "c", text: "Nie używać AI w ogóle", correct: false },
            { id: "d", text: "Ukrywać, że używasz AI", correct: false }
          ],
          shuffle: true,
          softHint: "Autentyczność to Twoje doświadczenia i perspektywa – AI ich nie ma.",
          successMessage: "Dokładnie! AI to narzędzie, ale Twój głos i doświadczenie są unikalne."
        }
      ]
    },

    // ═══════════════════════════════════════════════════════════════
    // ĆWICZENIE 4: AI w analizie i decyzjach (5 kroków)
    // Cel: Pokazać AI jako narzędzie do myślenia
    // ═══════════════════════════════════════════════════════════════
    {
      id: "d4_ex4",
      title: "AI jako partner do myślenia",
      icon: "brain",
      steps: [
        {
          id: "d4_ex4_s1",
          type: "choice",
          title: "AI w decyzjach",
          content: "Jak najlepiej wykorzystać AI przy podejmowaniu ważnej decyzji?",
          options: [
            { id: "a", text: "Pozwolić AI podjąć decyzję za Ciebie", correct: false },
            { id: "b", text: "Poprosić o analizę za i przeciw różnych opcji", correct: true },
            { id: "c", text: "Ignorować AI i zdać się na intuicję", correct: false },
            { id: "d", text: "Pytać AI, co ma zrobić", correct: false }
          ],
          shuffle: true,
          softHint: "AI może pomóc ZOBACZYĆ więcej perspektyw, ale decyzja należy do Ciebie.",
          successMessage: "Tak! AI to świetne narzędzie do eksploracji opcji i argumentów."
        },
        {
          id: "d4_ex4_s2",
          type: "shortPrompt",
          title: "Analiza decyzji",
          content: "Napisz prompt do analizy decyzji: \"Czy powinienem zmienić pracę?\"",
          placeholder: "Pomyśl krok po kroku i przeanalizuj...",
          minLength: 80,
          requiredElements: ["krok|analiz|rozważ", "prac|karier|zmian", "za i przeciw|plusy|minusy|korzyści|ryzyko"],
          softHint: "Użyj techniki Chain-of-Thought z dnia 2 – poproś o analizę etapami.",
          successMessage: "Świetny prompt do głębokiej analizy! AI pomoże Ci zobaczyć pełny obraz."
        },
        {
          id: "d4_ex4_s3",
          type: "choice",
          title: "Devil's Advocate",
          content: "Technika \"Devil's Advocate\" polega na:",
          options: [
            { id: "a", text: "Proszeniu AI o krytykę Twojego pomysłu", correct: true },
            { id: "b", text: "Ignorowaniu negatywnych opinii", correct: false },
            { id: "c", text: "Proszeniu o same pozytywne opinie", correct: false },
            { id: "d", text: "Unikaniu trudnych pytań", correct: false }
          ],
          shuffle: true,
          softHint: "\"Devil's Advocate\" to ktoś, kto celowo szuka słabych punktów w pomyśle.",
          successMessage: "Dokładnie! Poproszenie AI o znalezienie słabości pomysłu wzmacnia Twoją strategię."
        },
        {
          id: "d4_ex4_s4",
          type: "choice",
          title: "Burza mózgów z AI",
          content: "Który prompt da najlepsze wyniki brainstormingu?",
          options: [
            { id: "a", text: "\"Daj mi pomysły\"", correct: false },
            { id: "b", text: "\"Pomysły na biznes\"", correct: false },
            { id: "c", text: "\"Wygeneruj 20 niekonwencjonalnych pomysłów na [temat]. Nie oceniaj ich – chcę ilość, nie jakość. Uwzględnij pomysły szalone, praktyczne i łączące różne dziedziny.\"", correct: true },
            { id: "d", text: "\"Co powinienem zrobić?\"", correct: false }
          ],
          shuffle: true,
          softHint: "Brainstorming to ilość + różnorodność, potem dopiero selekcja.",
          successMessage: "Tak! Ten prompt da Ci bogaty materiał do dalszej pracy."
        },
        {
          id: "d4_ex4_s5",
          type: "fill",
          title: "Podsumowanie",
          content: "Dokończ zdanie:",
          template: "AI nie podejmuje za Ciebie decyzji, ale pomaga _______ więcej opcji.",
          correctAnswers: ["zobaczyć", "dostrzec", "zauważyć", "rozważyć", "przeanalizować", "zbadać"],
          minLength: 5,
          softHint: "AI rozszerza Twoje pole widzenia.",
          successMessage: "Właśnie tak! AI to narzędzie do lepszego WIDZENIA, nie do decydowania."
        }
      ]
    },

    // ═══════════════════════════════════════════════════════════════
    // ĆWICZENIE 5: Podsumowanie i misja (4 kroki)
    // Cel: Zamknąć dzień z planem działania
    // ═══════════════════════════════════════════════════════════════
    {
      id: "d4_ex5",
      title: "Twój plan działania",
      icon: "trophy",
      steps: [
        {
          id: "d4_ex5_s1",
          type: "choice",
          title: "Quiz: Główna korzyść",
          content: "Jaka jest główna korzyść z używania AI w pracy?",
          options: [
            { id: "a", text: "Można przestać myśleć", correct: false },
            { id: "b", text: "Oszczędność czasu na powtarzalnych zadaniach i więcej perspektyw przy decyzjach", correct: true },
            { id: "c", text: "AI zawsze ma rację", correct: false },
            { id: "d", text: "Można zastąpić wszystkich pracowników", correct: false }
          ],
          shuffle: true,
          softHint: "Przypomnij sobie dzisiejsze ćwiczenia – gdzie AI najbardziej pomagało?",
          successMessage: "Dokładnie! Czas + perspektywa = główne korzyści."
        },
        {
          id: "d4_ex5_s2",
          type: "choice",
          title: "Quiz: AI Coach",
          content: "Do czego najlepiej używać AI Coacha?",
          options: [
            { id: "a", text: "Do rozwiązywania wszystkich problemów", correct: false },
            { id: "b", text: "Do wyjaśniania trudnych pojęć i uzyskiwania wskazówek", correct: true },
            { id: "c", text: "Do zabawy", correct: false },
            { id: "d", text: "Lepiej nie używać", correct: false }
          ],
          shuffle: true,
          softHint: "AI Coach to mentor, nie maszyna do odpowiedzi.",
          successMessage: "Tak! AI Coach wyjaśnia i doradza – to Twój osobisty mentor."
        },
        {
          id: "d4_ex5_s3",
          type: "choice",
          title: "Wybierz jedno zadanie",
          content: "Które zadanie w TWOJEJ pracy wypróbujesz z AI w tym tygodniu?",
          options: [
            { id: "a", text: "Pisanie emaili lub odpowiedzi", isChoice: true },
            { id: "b", text: "Tworzenie raportów lub podsumowań", isChoice: true },
            { id: "c", text: "Generowanie pomysłów lub treści", isChoice: true },
            { id: "d", text: "Analizowanie decyzji lub problemów", isChoice: true }
          ],
          shuffle: false,
          softHint: "Wybierz coś, co robisz regularnie – tam zobaczysz największą korzyść.",
          successMessage: "Świetny wybór! Zacznij od jednego zadania i rozwijaj."
        },
        {
          id: "d4_ex5_s4",
          type: "choice",
          title: "Dzień 4 ukończony!",
          content: "Gratulacje! Masz dostęp do AI Coacha i wiesz, jak używać AI w pracy. Co dalej?",
          options: [
            { id: "a", text: "Wróć do listy lekcji", isChoice: true },
            { id: "b", text: "Wypróbuj AI Coacha jeszcze raz", isChoice: true }
          ],
          shuffle: false,
          softHint: "Wybierz swoją ścieżkę!",
          successMessage: "Dzień 4 za Tobą! Masz teraz prawdziwe narzędzia do pracy z AI. Praktykuj!"
        }
      ]
    }
  ]
};

export default day4Content;
